// extracted by mini-css-extract-plugin
module.exports = {"placeholderText":"File_placeholderText__2AsZa","textAnnotation":"File_textAnnotation__16En6"};